import { useTransition } from "./TransitionContext";

const { memo, useCallback } = window.React;

function GridItem({ post, gridItemClasses = "" }) {
    const { stateMap, setItem, toggle, deleteItem } = useTransition();

    const { status } = stateMap.get(post?.ID) || { status: "preEnter" };
    const classNames = [
        gridItemClasses,
        "resource-hub-grid-item card-appear",
        status,
    ]
        .filter(Boolean)
        .join(" ");

    const itemCallbackRef = useCallback(
        (node) => {
            if (node) {
                setItem(post?.ID);
                toggle(post?.ID, true);
                return;
            }

            deleteItem(post?.ID);
        },
        [deleteItem, setItem, post?.ID, toggle],
    );

    return (
        <div
            className={classNames}
            id={`post-id-${post?.ID}`}
            ref={itemCallbackRef}
        >
            <a
                className="card add-hover-scale-up h-100 bg-light-subtle border rounded-3 text-decoration-none link-reset"
                href={post?.permalink}
                style={{ overflow: "clip" }}
            >
                {post?.hub_img_markup ? (
                    <div dangerouslySetInnerHTML={{ __html: post.hub_img_markup }} />
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: post?.featured_image_markup }} />
                )}
                <div className="card-body d-flex flex-column p-3 justify-content-between align-items-start flex-grow-1">
                    <div className="flex-grow-1">
                        <div className="mt-3 mb-2 ">
                            <span className="text-uppercase font-weight-bold"></span>

                            {post?.sponsor_name && (
                                <div className="text-small mt-n1">
                                    <span className="text-gray">Presented by </span>{" "}
                                    {post?.sponsor_name}
                                </div>
                            )}
                        </div>

                        <h2 className="h3 text-left font-heading">
                            {(post?.post_meta?.hub_alt_title?.[0].length &&
                                post?.post_meta?.hub_alt_title?.[0]) ||
                                post?.post_title}
                        </h2>
                    </div>

                    <a
                        href={post?.permalink}
                        className="btn btn-outline-primary mt-3 text-small fw-bold custom-rc-button"
                    >
                        View
                    </a>
                </div>
            </a>
        </div>
    );
}

export default memo(GridItem);
